import React, { Fragment } from 'react'
import styled from 'styled-components'

import CalendarContent from './CalendarContent'

const StyledContainer = styled.div`
  width: 100%;
  padding: 0.5em 0;
  display: flex;
`
const CalendarRow = ({ children, days, selectedWeek, week, flexibleDates, cursor, ...props }) => (
  <Fragment>
    <StyledContainer>{days}</StyledContainer>
    <CalendarContent
      week={week}
      children={children}
      selectedWeek={selectedWeek}
      isOpen={selectedWeek === week && children}
      showAccordion={flexibleDates[cursor]}
      {...props}
    />
  </Fragment>
)

export default CalendarRow



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/CalendarRow.js